import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';

import { NewAnswerFooter } from '../../components/NewAnswer/parts/NewAnswerFooter';
import { addQuestionActions } from '../../actions/newQuestion/addQuestionActions';
import { getQuestionText } from '../../selectors/newQuestion';

export const NewQuestionFooterContainer = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  const text = useSelector(getQuestionText);

  const onClick = () => {
    dispatch(addQuestionActions());
  };

  return (
    <NewAnswerFooter
      next={
        <Button
          disabled={text.length === 0}
          data-testid="publish"
          onClick={onClick}
          fullWidth={isMobile}
          size={isMobile ? 'M' : 'XS'}
        >
          Опубликовать
        </Button>
      }
    />
  );
};
